import type { MouseEvent } from "react";

import type { NavigateFunction } from "src/router";

export const openUrl = (
  url: string,
  navigate: NavigateFunction,
  event: MouseEvent,
  openLinksExternally: boolean = false,
) => {
  if (openLinksExternally || event.metaKey || event.ctrlKey) {
    openUrlInNewTab(url);
    return true;
  } else {
    navigate(url);
    return false;
  }
};

export const openUrlInNewTab = (url: string) => {
  const slug = window.location.pathname.split("/")[1];
  const urlWithSlug = url.startsWith(`/${slug}`) ? url : `/${slug}${url}`;
  const win = window.open(urlWithSlug, "_blank");
  win?.focus();
};
